import React, { useEffect, useMemo } from 'react';
import CustomSelect from '../../components/CustomSelect';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { SingleCommonType } from '../../types';
import { versionPlaceholder } from '../../constants/placeholder';
import { commonBackInfo } from '../../utils';
import { useIntl } from 'umi';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function VersionSelect({
  onChange,
  defaultValue,
  defaultKey,
  filterValue,
  filterOptions,
  oriDefaultFilter,
  lang,
}: SingleCommonType) {
  const options = useMemo(() => {
    if (!filterOptions) {
      return [];
    }
    return filterOptions.map((item: any) => ({
      text: item.version,
      value: item.date,
    }));
  }, [filterOptions]);

  const filterValueMemo = useMemo(() => {
    const value = filterValue || {};
    return {
      ...value,
      version: (value.version_times || []).map(
        (item: { release_time: any }) => item.release_time,
      ),
    };
  }, [filterValue]);

  const defaultValueMemo = useMemo(() => {
    const value = defaultValue || {};
    return {
      ...value,
      version: (value.version_times || []).map(
        (item: { release_time: any }) => item.release_time,
      ),
    };
  }, [defaultValue]);

  const {
    selects: versionSelects,
    setSelects: setVersionSelects,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue: defaultValueMemo,
    filterValue: filterValueMemo,
    defaultKey: 'version',
    oriDefaultFilter,
    options: options.map((item: any) => item.value),
  });

 
  const { formatMessage } = useIntl();
  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  function getBackData() {
    const [text, isAll] = getButtonElement();
    const data = options
      .map((item: any) => {
        if (versionSelects.includes(item.value)) {
          return {
            release_time: item.value,
            version_name: item.text,
          };
        }
      })
      .filter(Boolean);

    return { data, text, isAll };
  }

  useEffect(() => {
    const { data, text } = getBackData();

    onChange?.(
      'version',
      commonBackInfo(
        {
          // version: isAll ? [] : versionSelects, 后端让先去掉该参数，这个参数导致数据膨胀
          version_times: data,
        },
        { [defaultKey]: text },
      ),
    );
  }, [versionSelects, formatMessage]);

  return (
    <div className={`version-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        placeholderText={versionPlaceholder[lang]}
        onClear={() => setVersionSelects([])}
        selectOptionsInfo={[versionSelects, setVersionSelects]}
        options={options}
        pointKey={FilterButtonPoint.version}
        getBackData={getBackData}
      ></CustomSelect>
    </div>
  );
}
